
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
    name: 'OperationLog',
    components: {
    }
})
export default class extends Vue {
    @Prop({ required: true }) private log!: any 
}
